import { useMemo } from "react";
import { ToWords } from "to-words";

export default function IntToEnglish({ total }) {
  // Memoize the ToWords instance so it's created once
  const toWords = useMemo(
    () =>
      new ToWords({
        localeCode: "hi-IN",
        converterOptions: {
          currency: true,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
          currencyOptions: {
            name: "Rupee",
            symbol: "₹",
            fractionalUnit: {
              name: "Paisa",
              plural: "Paise",
              symbol: "",
            },
          },
        },
      }),
    []
  );

  // Convert the number to words
  const words = toWords.convert(total);

  return words;
}
